import { LicensesApi } from './types';

const base = '/licenses';
const documents = `${base}/documents`;
const etiquetas = `${base}/etiquetas`;

export const licensesApi: Readonly<LicensesApi> = {
  adelantoVacacional: (filters) => `${base}/adelanto-vacacional/${filters}`,
  bossLicenses: (filters) => `${base}/boss/${filters}`,
  bossWarnings: (filters) => `${base}/boss/warnings/${filters}`,
  certificate: (filters) => `${documents}/certificate/${filters}`,
  certificateById: (id, filters) => `${documents}/certificate/${id}${filters}`,
  currentUser: (filters) => `${base}/current-user/${filters}`,
  currentUserCancelById: (id, filters) =>
    `${base}/current-user/${id}/cancel/${filters}`,
  documentsUpload: (filters) => `${documents}/upload/${filters}`,
  documentsUploadMessage: (filters) => `${documents}/mensaje/${filters}`,
  feriados: (filters) => `${base}/feriados/${filters}`,
  eventHandler: (id, event, filters) => `${base}/${id}/${event}${filters}`,
  gantt: (filters) => `${base}/gantt/${filters}`,
  license: (filters) => `${base}/${filters}`,
  licenseById: (id, filters) => `${base}/${id}${filters}`,
  manual: (filters) => `${base}/manual/${filters}`,
  manualById: (id, filters) => `${base}/manual/${id}${filters}`,
  medicalExtension: (id, filters) => `${base}/${id}/extend/${filters}`,
  notMedical: (filters) => `${base}/licencia-no-medica/${filters}`,
  otras: (filters) => `${base}/link-licencias/${filters}`,
  tags: (filters) => `${etiquetas}/${filters}`,
  tagsAutocomplete: (filters) => `${etiquetas}/autocomplete/${filters}`,
  tagsEdit: (id, filters) => `${etiquetas}/${id}/asignar/${filters}`,
  tutoriales: (filters) => `${base}/tutoriales/${filters}`,
  warnings: (filters) => `${base}/warning/${filters}`,
};
